import type { ProductFileRouter } from "replo-publisher/src/trpc/routers/productFile";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: productFileRouter,
  client: productFileClient,
  utils: productFileUtils,
  options: productFileOptions,
} = createTrpcRouterConfig<ProductFileRouter>({
  path: "productFile",
  queryClient: getNamespacedQueryClient("productFile"),
});

export {
  productFileClient,
  productFileRouter,
  productFileUtils,
  productFileOptions,
};
